import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { CalendarPlus, CheckCircle2, Phone, Trash2 } from "lucide-react";

const REQ_STATUS = {
  new: "bg-amber-100 text-amber-800 border-amber-200",
  contacted: "bg-blue-100 text-blue-800 border-blue-200",
  done: "bg-emerald-100 text-emerald-800 border-emerald-200",
};

export default function RequestsList({ requests, fmtDate, onConvert, onStatus, onDelete, canDelete = true }) {
  if (!requests.length)
    return <div className="bg-white rounded-2xl border border-slate-200 p-12 text-center text-slate-400" data-testid="requests-list">No booking requests yet.</div>;
  return (
    <div className="space-y-4" data-testid="requests-list">
      {requests.map((r) => (
        <div key={r.id} data-testid="request-item" className="bg-white rounded-2xl border border-slate-200 p-5 flex flex-col sm:flex-row sm:items-center gap-4">
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 flex-wrap">
              <span className="font-semibold text-slate-900">{r.patient_name}</span>
              <Badge variant="outline" className={`capitalize ${REQ_STATUS[r.status] || ""}`}>{r.status}</Badge>
            </div>
            <div className="text-sm text-slate-500 mt-1 flex flex-wrap gap-x-4 gap-y-1">
              <span className="flex items-center gap-1"><Phone className="h-3.5 w-3.5" />{r.phone}</span>
              <span>For <b className="text-slate-700">{r.doctor_name}</b></span>
              {r.preferred_date && <span>Preferred: {fmtDate(r.preferred_date)}</span>}
            </div>
            {r.message && <p className="text-sm text-slate-600 mt-2 bg-slate-50 rounded-lg px-3 py-2">{r.message}</p>}
          </div>
          <div className="flex gap-2 shrink-0">
            <Button data-testid="convert-request-button" size="sm" className="bg-teal-600 hover:bg-teal-700 text-white" onClick={() => onConvert(r)}>
              <CalendarPlus className="h-4 w-4 mr-1" /> Convert to Visit
            </Button>
            {r.status !== "contacted" && (
              <Button size="sm" variant="outline" onClick={() => onStatus(r.id, "contacted")}>Mark Contacted</Button>
            )}
            {r.status !== "done" && (
              <Button size="sm" variant="outline" onClick={() => onStatus(r.id, "done")}>
                <CheckCircle2 className="h-4 w-4 mr-1" /> Done
              </Button>
            )}
            {canDelete && (
              <Button size="icon" variant="ghost" className="text-rose-600" onClick={() => onDelete(r.id)} data-testid="delete-request-button">
                <Trash2 className="h-4 w-4" />
              </Button>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
